/*
* This code is the intellectual property of Bulb Inc. and other software publishers.
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component,
  EventEmitter,
  forwardRef,
  Input, OnInit, Output, TemplateRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

import { MenuItem, ColorOptions, MenuItemClickEvent } from '../types';
import { getMenuItemModels, findSelectedOption } from './radio-list.utilities';

@Component({
  selector: 'bulb-radio-list',
  templateUrl: './radio-list.component.html',
  styleUrls: ['./radio-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioListComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class RadioListComponent implements OnInit, ControlValueAccessor {
  public ColorOptions = ColorOptions;

  public value: any;

  onChange = (value: any) => {};

  onTouched = () => {};

  public formGroup: UntypedFormGroup = this.fb.group({});

  public models: Array<string>;

  // The footer template passed in from the parent component.
  @Input() footerTemplate: TemplateRef<any>;

  @Input() menuItems: Array<MenuItem>;

  @Output() menuItemClicked: EventEmitter<MenuItemClickEvent> = new EventEmitter<MenuItemClickEvent>();

  constructor(private fb: UntypedFormBuilder) { }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);

    this.models.forEach((m) => {
      this.formGroup.patchValue({
        [m]: findSelectedOption(this.menuItems.filter(({ model }) => model === m), this.value[m]),
      });
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.models = getMenuItemModels(this.menuItems);

    this.models.forEach((m) => {
      this.formGroup.addControl(m, new UntypedFormControl(findSelectedOption(this.menuItems, this.value)));
    });

    // TODO: unsubscribe
    this.formGroup.valueChanges.subscribe((value) => {
      this.onChange(value);
    });
  }
}
